/**
 * @flow
 * @relayHash 08e5f0728fdecc504c8570def7ba1248
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PortfolioLoaderFragment_viewer$ref = any;
export type PortfolioLoaderQueryVariables = {|
  first: number,
  offset: number,
  accountId: string,
|};
export type PortfolioLoaderQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: PortfolioLoaderFragment_viewer$ref
  |}
|};
export type PortfolioLoaderQuery = {|
  variables: PortfolioLoaderQueryVariables,
  response: PortfolioLoaderQueryResponse,
|};
*/


/*
query PortfolioLoaderQuery(
  $first: Int!
  $offset: Int!
  $accountId: ID!
) {
  viewer {
    ...PortfolioLoaderFragment_viewer_4tQiFT
    id
  }
}

fragment PortfolioLoaderFragment_viewer_4tQiFT on Query {
  accounts(first: $first, offset: $offset, id: $accountId) {
    edges {
      node {
        id
        name
        portfolios {
          edges {
            node {
              id
              trackingVue {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "accountId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v2 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PortfolioLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PortfolioLoaderFragment_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "accountId",
                "variableName": "accountId"
              },
              (v1/*: any*/),
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PortfolioLoaderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "accounts",
            "storageKey": null,
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "accountId"
              },
              (v2/*: any*/)
            ],
            "concreteType": "AccountNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "AccountNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AccountNode",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "portfolios",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfolioNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PortfolioNode",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "trackingVue",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "VueNode",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PortfolioLoaderQuery",
    "id": null,
    "text": "query PortfolioLoaderQuery(\n  $first: Int!\n  $offset: Int!\n  $accountId: ID!\n) {\n  viewer {\n    ...PortfolioLoaderFragment_viewer_4tQiFT\n    id\n  }\n}\n\nfragment PortfolioLoaderFragment_viewer_4tQiFT on Query {\n  accounts(first: $first, offset: $offset, id: $accountId) {\n    edges {\n      node {\n        id\n        name\n        portfolios {\n          edges {\n            node {\n              id\n              trackingVue {\n                id\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3efc5777346b164e2dcc7e5050d96d73';
module.exports = node;
